import { render, staticRenderFns } from "./FormArboSnapshot.vue?vue&type=template&id=48cfb8a7&"
import script from "./FormArboSnapshot.vue?vue&type=script&lang=js&"
export * from "./FormArboSnapshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports